<script>
  import { DataHandler, Datatable, Th, ThFilter } from "@vincjo/datatables";
  import { onMount } from "svelte";
  import Conexoes from "./../../Classes/Conexoes.js";
    import { DadosLogin, permissaoUsuario } from "../../Classes/Stores.js";
    LoadingTela
    import Constantes from "../../Classes/Constantes.js";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import Loading from "../../componentes_basicos/Loading.svelte";
    
  

  let conexao = new Conexoes();
  let nomes = [];
  let resultado = [];
  let handler = null;
  let array = [];
  let rows;
  let arrayAtributosNumericos = [];
  let somas = [];
  let isLoading=false;
  // Cria array com nomes das chaves que contém valores numéricos
  function testaAtributosComValoresNumericos(obj) {
    const numericAttributes = [];
    const numericRegex = /^-?\d+(\.\d+)?$/; // Regex para números inteiros e decimais

    for (const key in obj) {
      const value = obj[key];
      if (
        typeof value === "number" ||
        (typeof value === "string" && numericRegex.test(value))
      ) {
        numericAttributes.push(key);
      }
    }
    return numericAttributes;
  }

  async function BuscarNomeDosRelatorios() {
    nomes = await conexao.conecta("consultas.php", {
      query_code: "buscar_relatorios",
      id_campeonato: 1,
      tipo_usuario: $DadosLogin.tipo_usuario,
    });
  }

  onMount(() => {
    BuscarNomeDosRelatorios();
  });

  async function BuscarRelatorios(e) {
    let relatorioEscolhido = e.target.value;
    if(!relatorioEscolhido){
      return;
    }
    isLoading=true;
    let resul = await conexao.conecta(
      "relatorios/BuscaRelatoriosEscolhido2.php",
      { tipo_relatorio: relatorioEscolhido }
    );
     
    arrayAtributosNumericos = testaAtributosComValoresNumericos(resul[0]);
    // remove atributo com nome 'Quantidade' já que sempre será inteiro
    arrayAtributosNumericos = arrayAtributosNumericos.filter((propriedade) => propriedade !== "Quantidade");


    // Adicionando o atributo `id` sequencial
    resul = resul.map((item, index) => ({ ...item, id: index + 1 }));
    resultado = resul;

    handler = new DataHandler(resultado, {
      rowsPerPage: 1000,
      i18n: {
        search: "Procura...",
        filter: "Filtro da coluna...",
        rowCount: "Exibindo de {start} até {end} de {total}",
        noRows: "Não há resultados para esse filtro",
        previous: "Anterior",
        next: "Próximo",
      },
    });

    rows = handler.getRows();

    // Extrair os nomes das propriedades e remover o elemento com nome 'id'
    array = Object.keys(resultado[0]);
    array = array.filter((propriedade) => propriedade !== "id");
    // Criar um array de arrays onde cada elemento é ['nome_propriedade', 'nome_propriedade']
    array = array.map((propriedade) => [propriedade, propriedade]);
    isLoading=false;
  }
</script>
<LoadingTela {isLoading} />
{#if  $permissaoUsuario.permissoes || $permissaoUsuario.permissoes.includes(Constantes.pode_ver_relatorios)}

<div class="margem">
  <div class="custom-div">
    <div>
      Selecione o relatório:
      <select class="custom-select" on:change={BuscarRelatorios}>
        <option value="">Selecione um relatório</option>
        {#each nomes as nome, i}
          <option value={nome.id}>{nome.item}</option>
        {/each}
      </select>
    </div>
  </div>
  {#if resultado.length > 0}
    <Datatable
      {handler}
      rowsPerPage={false}
      rowCount={false}
      pagination={false}
    >
      <table>
        <thead>
          <tr>
            {#each array as [coluna, label]}
              <Th {handler} orderBy={coluna}>{label}</Th>
            {/each}
          </tr>
        </thead>
        <tbody>
          {#each $rows as row}
            <tr>
              {#each array as [coluna, label]}
                {#if arrayAtributosNumericos.includes(label)}
                  <td
                    >{parseFloat(row[coluna]).toLocaleString("pt-BR", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    })}</td
                  >
                {:else}
                  <td>{row[coluna]}</td>
                {/if}
              {/each}
            </tr>
          {/each}
        </tbody>
      </table>
    </Datatable>
  {/if}
</div>
{/if}
<style>
  /*
  .container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .container > div {
    padding: 5px;
    border-radius: 5px;
    border: 1px solid rgb(15, 2, 197);
    text-align: center;
  }
  */

  thead {
    background: #fff;
  }
  tbody td {
    border: 1px solid #f5f5f5;
    padding: 4px 10px;
  }
  tbody tr {
    transition: all, 0.2s;
  }
  tbody tr:hover {
    background: #f5f5f5;
  }

  .margem {
    margin-top: 70px;
    margin-bottom: 70px;
  }

  .custom-div {
    background-color: #cbd4fd;
    color: rgb(0, 0, 0);
    padding: 15px;
    border-radius: 5px;
  }

  .custom-select {
    display: block;
    width: 100%;
    padding: 8px;
    font-size: 16px;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .custom-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
</style>
